import styles from "./HorizontalProgressRow.module.css";

const HorizontalProgressRow = ({
  label,
  value = 0,
  total = 0,
  color,
  isLoading,
  onClick,
}) => {
  const percent = total ? (value / total) * 100 : 0;

  return (
    <div
      className={`${styles.row} ${onClick ? styles.clickable : ""}`}
      onClick={onClick}
    >
      <span className={styles.label}>{label}</span>

      <div className={styles.track}>
        {isLoading ? (
          <div className={`shimmer ${styles.bar}`} style={{ width: "40%" }} />
        ) : (
          value > 0 && (
            <div
              className={styles.bar}
              style={{ width: `${percent}%`, background: color }}
            />
          )
        )}
      </div>

      <div className={styles.stats}>
        <span className={styles.value}>{isLoading ? "-" : value}</span>
        <span className={styles.percent}>
          {isLoading ? "-" : `${percent.toFixed(1)}%`}
        </span>
      </div>
    </div>
  );
};

export default HorizontalProgressRow;